(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function css(text) {
    var s = document.createElement('style');
    s.setAttribute('data-bd-simplify', '');
    s.textContent = text;
    document.head.appendChild(s);
  }

  function wrapDetails(summaryText, nodes, className) {
    var list = nodes.filter(Boolean);
    if (!list.length) return null;
    var d = document.createElement('details');
    d.className = className || 'bd-more';
    var s = document.createElement('summary');
    s.textContent = summaryText;
    d.appendChild(s);
    list[0].parentNode.insertBefore(d, list[0]);
    list.forEach(function (n) { d.appendChild(n); });
    return d;
  }

  function simplifyHome() {
    var home = document.querySelector('.ps-home');
    if (!home) return;

    // Onderdelen die we op de homepage niet tonen worden verwijderd, niet alleen verborgen.
    ['.ps-hero__bulk', '.ps-hero__proof', '.ps-trust', '.ps-how', '.ps-bulk'].forEach(function (sel) {
      var n = home.querySelector(sel);
      if (n && n.parentNode) n.parentNode.removeChild(n);
    });

    css(
      '.ps-finder .ps-section-head p:nth-of-type(n+3){display:none}' +
      '.bd-more{margin-top:22px;border:1px solid #e3ded6;border-radius:14px;background:#faf8f4}' +
      '.bd-more>summary{cursor:pointer;list-style:none;padding:14px 16px;min-height:44px;display:flex;align-items:center;justify-content:space-between;gap:12px;font-weight:800;font-size:14px;color:#1f1f1f}' +
      '.bd-more>summary::-webkit-details-marker{display:none}' +
      '.bd-more>summary:after{content:"+";font-size:20px;font-weight:400;color:#961e20}' +
      '.bd-more[open]>summary:after{content:"\\2013"}' +
      '.bd-more>*:not(summary){margin-left:16px;margin-right:16px}' +
      '.bd-more>*:last-child{margin-bottom:16px}'
    );

    var main = home.querySelector('.ps-voordeel__main');
    if (main && main.textContent.indexOf('combineren') === -1) {
      main.innerHTML = '<strong>Vanaf 2 privacyfilters altijd 10% voordeel</strong>, automatisch verrekend. Verschillende maten combineren kan.';
    }

    ['laptop', 'monitor'].forEach(function (kind) {
      var panel = document.getElementById('ps-panel-' + kind);
      if (!panel) return;
      var finder = panel.querySelector(kind === 'laptop' ? '.ps-laptop-finder' : '.ps-monitor-finder');
      var aside = panel.querySelector('.ps-multi-order');
      var help = panel.querySelector('.ps-laptop-help');
      var details = wrapDetails('Staat je model er niet bij, weet je je maat of heb je meerdere apparaten?', [finder, aside, help]);
      if (!details) return;
      var feedback = panel.querySelector('[data-' + kind + '-feedback]');
      if (feedback && window.MutationObserver) {
        new MutationObserver(function () {
          if (!feedback.hidden && feedback.textContent.indexOf('Geen probleem') === 0) {
            details.open = true;
            setTimeout(function () { details.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 60);
          }
        }).observe(feedback, { attributes: true, childList: true, characterData: true, subtree: true });
      }
    });

    var items = home.querySelectorAll('.ps-faq__list > details');
    items.forEach(function (d, i) {
      d.open = false;
      if (i >= 5) d.style.display = 'none';
    });
  }

  function simplifyProduct() {
    css(
      '.bd-bulk__kicker,.bd-bulk__rows{display:none!important}' +
      '.bd-bulk{padding:10px 14px!important;gap:0!important}' +
      '.bd-bulk__savings{margin:0!important}' +
      '.bd-more-product{border-top:1px solid rgba(16,26,43,.12);border-bottom:1px solid rgba(16,26,43,.12)}' +
      '.bd-more-product>summary{cursor:pointer;list-style:none;min-height:48px;display:flex;align-items:center;justify-content:space-between;font-weight:800;font-size:14px}' +
      '.bd-more-product>summary::-webkit-details-marker{display:none}' +
      '.bd-more-product>summary:after{content:"+";font-size:20px;font-weight:400}' +
      '.bd-more-product[open]>summary:after{content:"\\2013"}' +
      '.bd-more-product>.ps-product-proof{padding-bottom:14px}'
    );

    var proof = document.querySelector('.ps-product-proof');
    if (proof && !proof.closest('.bd-more-product')) {
      var wrap = document.createElement('details');
      wrap.className = 'bd-more-product';
      var sum = document.createElement('summary');
      sum.textContent = 'Meer over dit filter: voordelen, specificaties en veiligheid';
      wrap.appendChild(sum);
      proof.parentNode.insertBefore(wrap, proof);
      wrap.appendChild(proof);
    }
  }

  ready(function () {
    if (document.querySelector('.ps-home')) simplifyHome();
    if (document.querySelector('[data-bd-fit], .ps-product-proof, .bd-bulk')) simplifyProduct();
  });
})();